const http = window.axios;

const api = {
  /**
   *  Dashboard V2
   */
  getTotalStatsData: (params) =>
    http.get(
      process.env.VUE_APP_BASE_DASHBOARD + "/dashboard/v1/getTotalStatsData",
      {
        params,
      }
    ),

  getOverviewData: (params) =>
    http.get(
      process.env.VUE_APP_BASE_DASHBOARD + "/dashboard/v1/getOverviewData",
      {
        params,
      }
    ),

  getIndexCompositionData: (params) =>
    http.post(
      process.env.VUE_APP_BASE_DASHBOARD +
        "/dashboard/v1/getIndexCompositionData",
      params
    ),

  getDashboardTokenData: (params) =>
    http.post(
      process.env.VUE_APP_BASE_DASHBOARD + "/dashboard/v1/getTokenData",
      params
    ),

  /**
   *  InviteRanking
   */
  queryInviteRankingTotalDealData: (params) =>
    http.get(
      process.env.VUE_APP_BASE +
        "/inviteActivity/queryInviteRankingTotalDealData",
      {
        params,
      }
    ),
  searchRankingData: (params) =>
    http.get(process.env.VUE_APP_BASE + "/inviteActivity/searchRankingData", {
      params,
    }),
  createInviteUserCode: (params, config) =>
    http.post(
      process.env.VUE_APP_BASE + "/inviteActivity/createInviteUserCode",
      params,
      config
    ),
  queryInviteRanking: (params) =>
    http.post(
      process.env.VUE_APP_BASE + "/inviteActivity/queryInviteRanking",
      params
    ),
  findMyInviteCode: (params) =>
    http.post(
      process.env.VUE_APP_BASE + "/inviteActivity/findMyInviteCode",
      params
    ),
  /**
   * Promotional activity related modules
   */
  // Query the marginX address based on the invitation code
  queryAddressByUserCode: (params) =>
    http.get(
      process.env.VUE_APP_BASE + "/inviteActivity/queryAddressByUserCode",
      { params }
    ),
  // Save inviter and invitee relationship
  createInviteRecord: (params, config) =>
    http.post(
      process.env.VUE_APP_BASE + "/inviteActivity/createInviteRecord",
      params,
      config
    ),

  // Check whether the two have an invitation relationship
  queryInviteRelation: (params) =>
    http.post(
      process.env.VUE_APP_BASE + "/inviteActivity/queryInviteRelation",
      params
    ),

  // searchRankingData: (params) =>
  //   http.post(
  //     process.env.VUE_APP_BASE + "/inviteActivity/searchRankingData",
  //     params
  //   ),

  searchInviteDetailPage: (params) =>
    http.post(
      process.env.VUE_APP_BASE + "/inviteActivity/searchInviteDetailPage",
      params
    ),

  /**
   * common data module
   */
  // Query the list of trading pairs
  queryPair: (params) =>
    http.post(process.env.VUE_APP_BASE + "/common/queryPair", params),
  // Query the latest transaction record table
  queryTrades: (params) =>
    http.post(process.env.VUE_APP_BASE + "/common/queryTrades", params),
  // Check the latest order Books
  queryOrderBook: (params) =>
    http.post(process.env.VUE_APP_BASE + "/common/queryOrderBook", params),
  // Query depth
  queryDepthInfo: (params) =>
    http.post(process.env.VUE_APP_BASE + "/common/queryDepthInfo", params),
  // K line data
  queryLineInfo: (params) =>
    http.post(process.env.VUE_APP_BASE + "/common/queryLineInfo", params),
  // Real-time query funding rate
  getFundingRateRealTime: (params) =>
    http.post(
      process.env.VUE_APP_BASE + "/common/getFundingRateRealTime",
      params
    ),
  // Query chain basic information list
  queryChainDetailList: (params) =>
    http.post(
      process.env.VUE_APP_BASE + "/common/queryChainDetailList",
      params
    ),
  // // Get trading pair exchange rate correlation
  // queryPairRateInfo: (params) =>
  //   http.post(process.env.VUE_APP_BASE + "/common/queryPairRateInfo", params),

  // Get trading pair exchange rate correlation
  queryPairRateInfo: (params) =>
    http.post(
      "https://testnet-data-source.marginx.io/api/v2/ticker/lastTradePrice",
      params
    ),

  /**
   * Address related modules
   */
  // Check balances
  queryBalance: (params) =>
    http.post(process.env.VUE_APP_BASE + "/address/queryBalance", params),
  // query cangw
  queryHoldBalance: (params) =>
    http.post(process.env.VUE_APP_BASE + "/address/queryHoldBalance", params),
  // Query the list of openOrders
  queryOpenOrder: (params) =>
    http.post(process.env.VUE_APP_BASE + "/address/queryOpenOrder", params),
  // Query order history
  queryOrderHistory: (params) =>
    http.post(process.env.VUE_APP_BASE + "/address/queryOrderHistory", params),
  // Query order TradeDetail
  queryTradeDetail: (params) =>
    http.post(process.env.VUE_APP_BASE + "/address/queryTradeDetail", params),
  // Query position list
  queryPosition: (params) =>
    http.post(process.env.VUE_APP_BASE + "/address/queryPosition", params),

  /**
   * Calculate price module
   */
  // Get system parameters
  queryChainSystemInfo: (params) =>
    http.post(
      process.env.VUE_APP_BASE + "/calculate/queryChainSystemInfo",
      params
    ),
  // Get funding rate information
  queryFunding: (params) =>
    http.post(process.env.VUE_APP_BASE + "/calculate/queryFunding", params),

  // Calculate the liquidation price
  queryLiquidation: (params) =>
    http.post(process.env.VUE_APP_BASE + "/calculate/queryLiquidation", params),
  // Data Statistics Module
  querySettleFunding: (params) =>
    http.post(
      process.env.VUE_APP_BASE + "/calculate/querySettleFunding",
      params
    ),

  /**
   * Data Statistics Module
   */
  // Funding Statistics - Liquidation List Data

  LiquidationStatisticPage: (params) =>
    http.post(
      process.env.VUE_APP_BASE +
        "/tradingDataStatistic/LiquidationStatisticPage",
      params
    ),

  // Funding Fee - Funding Rate
  getFundingRateResult: (params) =>
    http.post(
      process.env.VUE_APP_BASE + "/tradingDataStatistic/getFundingRateResult",
      params
    ),

  // Funding Fee - Funding Rate Page
  queryFundingRatePage: (params) =>
    http.post(
      process.env.VUE_APP_BASE + "/tradingDataStatistic/queryFundingRatePage",
      params
    ),

  // Funding Statistics - Open Interest
  holdPositionCount: (params) =>
    http.post(
      process.env.VUE_APP_BASE + "/tradingDataStatistic/holdPositionCount",
      params
    ),
  // Funding Statistics - List of Open Interests
  holdPositionList: (params) =>
    http.post(
      process.env.VUE_APP_BASE + "/tradingDataStatistic/holdPositionList",
      params
    ),
  // Fund Statistics - Liquidation Statistics
  liquidationStatistic: (params) =>
    http.post(
      process.env.VUE_APP_BASE + "/tradingDataStatistic/liquidationStatistic",
      params
    ),
  // Funding Statistics - Long and Short Ratio
  moreThanEmpty: (params) =>
    http.post(
      process.env.VUE_APP_BASE + "/tradingDataStatistic/moreThanEmpty",
      params
    ),
  //Index - Price Index, Mark Price Page Page
  queryOracleOrMarkPricePage: (params) =>
    http.post(
      process.env.VUE_APP_BASE +
        "/tradingDataStatistic/queryOracleOrMarkPricePage",
      params
    ),
  //Indices - Price Indices, Mark Prices
  queryPairOracleOrMarkPricePrice: (params) =>
    http.post(
      process.env.VUE_APP_BASE +
        "/tradingDataStatistic/queryPairOracleOrMarkPricePrice",
      params
    ),
  // User Statistics - Total Address Quantity, Position Address Quantity
  totalAddressStatistic: (params) =>
    http.post(
      process.env.VUE_APP_BASE + "/tradingDataStatistic/totalAddressStatistic",
      params
    ),

  /**
   * my assets
   */
  // Query the trading pair assets in the asset details
  findAccountPairBalance: (params) =>
    http.post(
      process.env.VUE_APP_BASE + "/myAccountBalance/findAccountPairBalance",
      params
    ),

  // Query account balance in asset details
  findAccountBalance: (params) =>
    http.post(
      process.env.VUE_APP_BASE + "/myAccountBalance/findAccountBalance",
      params
    ),

  /**
   * faucet recharge
   */
  faucet: (params, config) =>
    http.get("/activity/faucet", { params, ...config }),

  referralReward: (params) => http.get("/referral-reward", { params }),

  // dashboard
  /**
   * 指标数据-根据交易对查询地址活跃数量(获取当前月活跃地址数量、和最近24小时活跃数量)
   */
  queryActiveAccount: (params) =>
    http.post(
      process.env.VUE_APP_BASE + "/addressCountReport/queryActiveAccount",
      params
    ),
  /**
   * 累计数据-累计的用户地址信息(最近7天地址新增信息、目前总地址、最近24小时地址新增量)
   */
  queryAddressCountIncrease: (params) =>
    http.post(
      process.env.VUE_APP_BASE +
        "/addressCountReport/queryAddressCountIncrease",
      params
    ),
  /**
   *  流动资金图表
   */
  tvlAmount: (params) =>
    http.get(process.env.VUE_APP_BASE_AGG + "/api/v1/tvl_amount", { params }),
  /**
   * 交易数量图表
   */
  txsCount: (params) =>
    http.get(process.env.VUE_APP_BASE_AGG + "/api/v1/txs_count", { params }),
  /**
   * 交易量图表
   */
  tradingVolume: (params) =>
    http.get(process.env.VUE_APP_BASE_AGG + "/api/v1/trading_volume", {
      params,
    }),
  /**
   * 成交量图表
   */
  tradingVolumeBySymbols: (params) =>
    http.post(
      process.env.VUE_APP_BASE_AGG + "/api/v1/trading_volume_by_symbols",
      params
    ),
  /**
   * 手续费图表
   */
  tradingFeeBySymbols: (params) =>
    http.post(
      process.env.VUE_APP_BASE_AGG + "/api/v1/trading_fee_by_symbols",
      params
    ),
  /**
   * 交易数量图表
   */
  txsCountBySymbols: (params) =>
    http.post(
      process.env.VUE_APP_BASE_AGG + "/api/v1/txs_count_by_symbols",
      params
    ),
  /**
   * 查询FLows
   */
  flowsBySymbols: (params) =>
    http.post(
      process.env.VUE_APP_BASE_AGG + "/api/v1/flows_by_symbols",
      params
    ),
  /**
   * 查询MarginData
   */
  marginDataBySymbols: (params) =>
    http.post(
      process.env.VUE_APP_BASE_AGG + "/api/v1/margin_data_by_symbols",
      params
    ),
  /**
   * 标记价格K线
   */
  markPriceBySymbol: (params) =>
    http.post(
      process.env.VUE_APP_BASE_AGG + "/api/v1/mark_price_by_symbol",
      params
    ),
  /**
   * Oracle价格K线
   */
  oraclePriceBySymbol: (params) =>
    http.post(
      process.env.VUE_APP_BASE_AGG + "/api/v1/oracle_price_by_symbol",
      params
    ),
  /**
   * 风险保证金
   */
  riskMarginBySymbol: (params) =>
    http.post(
      process.env.VUE_APP_BASE_AGG + "/api/v1/risk_margin_by_symbol",
      params
    ),

  /**
   *  Rewards
   */
  // 交易活动地址收益明细
  addressRewardDetail: (params) =>
    http.post(
      process.env.VUE_APP_BASE + "/tradingActivity/addressRewardDetail",
      params
    ),

  // 获取账户收益历史记录
  addressRewardHistory: (params) =>
    http.post(
      process.env.VUE_APP_BASE + "/tradingActivity/addressRewardHistory",
      params
    ),
  // 获取交易挖矿活动该地址总交易usdt
  userMiningReward: (params) =>
    http.get(process.env.VUE_APP_BASE + "/tradingActivity/userMiningReward", {
      params,
    }),
  // 获取最高等级的NFT信息
  highLevelNftDetail: (params) =>
    http.post(process.env.VUE_APP_BASE + "/nft/highLevelNftDetail", params),
  // 获取参与活动人数
  tradingRewardParticipatingNumber: (params) =>
    http.get(
      process.env.VUE_APP_BASE +
        "/tradingActivity/tradingRewardParticipatingNumber",
      { params }
    ),
  // 获取交易奖励活动结束时间
  tradingRewardEndTime: (params) =>
    http.get(
      process.env.VUE_APP_BASE + "/tradingActivity/tradingRewardEndTime",
      { params }
    ),
};

export default api;
